import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
  Box,
} from "@mui/material";

const ReusableRoleTable = ({
  roles = [],
  permissionsList = [],
  handleView,
  handleEdit,
  handleDeleteClick,
}) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Role ID</TableCell>
            <TableCell>Role Name</TableCell>
            <TableCell>Menus</TableCell>
            {permissionsList.map((perm) => (
              <TableCell key={perm} className="table-fonts">
                {perm
                  .replace("add", "Add")
                  .replace("view", "View")
                  .replace("edit", "Edit")
                  .replace("delete", "Delete")
                  .replace("allaccess", "All Access")
                  .replace("noaccess", "No Access")}
              </TableCell>
            ))}
            <TableCell>Status</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {roles.length > 0 ? (
            roles.map((role, roleIndex) => {
              const rolePermissions = Object.entries(role.permissions || {});

              return rolePermissions.length > 0 ? (
                rolePermissions.map(([category, permissions], catIndex) => (
                  <TableRow key={`${roleIndex}-${catIndex}`}>
                    {catIndex === 0 && (
                      <>
                        {/* Role ID and Name */}
                        <TableCell
                          rowSpan={rolePermissions.length}
                          className="role-box"
                        >
                          {role.serial_no}
                        </TableCell>
                        <TableCell
                          rowSpan={rolePermissions.length}
                          className="role-box"
                        >
                          {role.name}
                        </TableCell>
                      </>
                    )}

                    {/* Category (Menu) */}
                    <TableCell>{category}</TableCell>

                    {/* Permissions */}
                    {permissionsList.map((perm) => (
                      <TableCell
                        key={perm}
                        sx={{
                          textAlign: "center",
                          color: permissions?.[perm] ? "green" : "red",
                        }}
                      >
                        {permissions?.[perm] ? "✔" : "✖"}
                      </TableCell>
                    ))}

                    {/* Status cell */}
                    {catIndex === 0 && (
                      <TableCell
                        rowSpan={rolePermissions.length}
                        className="role-box"
                      >
                        <Typography
                          variant="subtitle1"
                          className={`status-label ${
                            role.status === 0
                              ? "active"
                              : role.status === 1
                              ? "inactive"
                              : "unknown"
                          }`}
                        >
                          <span
                            className={`status-value ${
                              role.status === 0
                                ? "active"
                                : role.status === 1
                                ? "inactive"
                                : "unknown"
                            }`}
                          >
                            {role.status === 0
                              ? "Active"
                              : role.status === 1
                              ? "Inactive"
                              : "Unknown"}
                          </span>
                        </Typography>
                      </TableCell>
                    )}

                    {catIndex === 0 && (
                      <TableCell
                        rowSpan={rolePermissions.length}
                        className="role-box"
                      >
                        <Box className="button-list">
                          <Button
                            className="view-user-button"
                            variant="contained"
                            onClick={() => handleView(role)}
                            size="small"
                          >
                            View
                          </Button>

                          <Button
                            className="edit-user-button"
                            variant="contained"
                            color="primary"
                            onClick={() => handleEdit(role)}
                            size="small"
                          >
                            Edit
                          </Button>

                          <Button
                            className="delete-user-button"
                            variant="contained"
                            color="error"
                            onClick={() => handleDeleteClick(role.id)}
                            size="small"
                          >
                            Delete
                          </Button>
                        </Box>
                      </TableCell>
                    )}
                  </TableRow>
                ))
              ) : (
                <TableRow key={roleIndex}>
                  <TableCell>{role.serial_no}</TableCell>
                  <TableCell>{role.name}</TableCell>
                  <TableCell colSpan={permissionsList.length + 3}>
                    No permissions assigned.
                  </TableCell>
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableCell colSpan={permissionsList.length + 5}>
                <Typography align="center">No roles available.</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ReusableRoleTable;
